export const LIST_TOKEN = [
  { id: 0, image: require("@/assets/token_exchange/token_1.png") },
  { id: 1, image: require("@/assets/token_exchange/token_2.png") },
  { id: 2, image: require("@/assets/token_exchange/token_3.png") },
  { id: 3, image: require("@/assets/token_exchange/token_4.png") },
  { id: 4, image: require("@/assets/token_exchange/token_5.png") },
  { id: 5, image: require("@/assets/token_exchange/token_6.png") },
  { id: 6, image: require("@/assets/token_exchange/token_7.png") },
];
